import m from "mithril";
import { fetchWithAutoRefresh } from "../utils.js";

const KinerjaTarget = {
    targets: [],
    positions: [],
    loading: true,
    form: {
        targetType: 'deposit',
        targetInterval: 'daily',
        targetNumber: '',
        targetAssign: ''
    },

    loadData: async function() {
        this.loading = true;
        try {
            const [targetsRes, positionsRes] = await Promise.all([
                fetchWithAutoRefresh('/api/kinerja/targets'),
                fetchWithAutoRefresh('/api/kinerja/positions')
            ]);
            
            if (targetsRes.ok) {
                const data = await targetsRes.json();
                this.targets = data.data;
            }
            if (positionsRes.ok) {
                const data = await positionsRes.json();
                this.positions = data.data;
                if (this.positions.length > 0 && !this.form.targetAssign) {
                    this.form.targetAssign = this.positions[0];
                }
            }
        } catch (error) {
            console.error('Failed to load targets:', error);
        } finally {
            this.loading = false;
            m.redraw();
        }
    },

    saveTarget: async function(e) {
        e.preventDefault();
        try {
            const res = await fetchWithAutoRefresh('/api/kinerja/targets', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(this.form)
            });
            if (res.ok) {
                this.form.targetNumber = '';
                this.loadData();
            } else {
                const err = await res.json();
                alert(err.error || 'Failed to save target');
            }
        } catch (error) {
            alert('Error saving target');
        }
    },

    deleteTarget: async function(id) {
        if (!confirm('Hapus target ini?')) return;
        try {
            const res = await fetchWithAutoRefresh(`/api/kinerja/targets?id=${id}`, {
                method: 'DELETE'
            });
            if (res.ok) {
                this.loadData();
            }
        } catch (error) {
            alert('Error deleting target');
        }
    },

    oninit: function() {
        this.loadData();
    },

    view: function() {
        return m("div", { class: "p-6" }, [
            m("div", { class: "bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 mb-8 border border-gray-100 dark:border-gray-700" }, [
                m("h2", { class: "text-xl font-bold text-gray-800 dark:text-white mb-6" }, "Tambah Target Kinerja"),
                m("form", { class: "grid grid-cols-1 md:grid-cols-4 gap-4 items-end", onsubmit: (e) => this.saveTarget(e) }, [
                    m("div", [
                        m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Tipe Target"),
                        m("select", {
                            class: "w-full p-2.5 rounded-lg border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white",
                            value: this.form.targetType,
                            onchange: (e) => this.form.targetType = e.target.value
                        }, [
                            m("option", { value: "withdrawal" }, "Penarikan"),
                            m("option", { value: "deposit" }, "Setoran"),
                            m("option", { value: "loan" }, "Pinjaman")
                        ])
                    ]),
                    m("div", [
                        m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Interval"),
                        m("select", {
                            class: "w-full p-2.5 rounded-lg border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white",
                            value: this.form.targetInterval,
                            onchange: (e) => this.form.targetInterval = e.target.value
                        }, [
                            m("option", { value: "daily" }, "Harian"),
                            m("option", { value: "weekly" }, "Mingguan"),
                            m("option", { value: "monthly" }, "Bulanan")
                        ])
                    ]),
                    m("div", [
                        m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Target (Jumlah Transaksi)"),
                        m("input", {
                            type: "number",
                            class: "w-full p-2.5 rounded-lg border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white",
                            placeholder: "Contoh: 50",
                            value: this.form.targetNumber,
                            oninput: (e) => this.form.targetNumber = e.target.value,
                            required: true
                        })
                    ]),
                    m("div", [
                        m("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Jabatan"),
                        m("select", {
                            class: "w-full p-2.5 rounded-lg border border-gray-200 dark:border-gray-600 dark:bg-gray-700 dark:text-white",
                            value: this.form.targetAssign,
                            onchange: (e) => this.form.targetAssign = e.target.value,
                            required: true
                        }, [
                            this.positions.map(pos => m("option", { value: pos }, pos))
                        ])
                    ]),
                    m("div", { class: "md:col-start-4 flex justify-end" }, [
                        m("button", {
                            type: "submit",
                            class: "bg-orange-600 hover:bg-orange-700 text-white font-bold py-2.5 px-6 rounded-lg transition-colors flex items-center shadow-lg"
                        }, [
                            m("i", { class: "ri-add-line mr-2" }),
                            "Simpan Target"
                        ])
                    ])
                ])
            ]),

            m("div", { class: "bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden border border-gray-100 dark:border-gray-700" }, [
                m("div", { class: "px-6 py-4 border-b border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-750" }, [
                    m("h2", { class: "text-lg font-bold text-gray-800 dark:text-white" }, "Data Target Kinerja")
                ]),
                m("div", { class: "overflow-x-auto" }, [
                    m("table", { class: "w-full text-left" }, [
                        m("thead", { class: "bg-gray-50 dark:bg-gray-750 text-gray-600 dark:text-gray-400 text-xs uppercase tracking-wider font-semibold" }, [
                            m("tr", [
                                m("th", { class: "px-6 py-3" }, "Jabatan"),
                                m("th", { class: "px-6 py-3" }, "Tipe"),
                                m("th", { class: "px-6 py-3" }, "Interval"),
                                m("th", { class: "px-6 py-3 text-right" }, "Target (Transaksi)"),
                                m("th", { class: "px-6 py-3 text-center" }, "Aksi")
                            ])
                        ]),
                        m("tbody", { class: "divide-y divide-gray-100 dark:divide-gray-700" }, [
                            this.loading ? m("tr", m("td", { colspan: 5, class: "px-6 py-10 text-center text-gray-500" }, "Memuat data...")) :
                            this.targets.length === 0 ? m("tr", m("td", { colspan: 5, class: "px-6 py-10 text-center text-gray-500" }, "Belum ada target yang diset.")) :
                            this.targets.map(target => m("tr", { class: "hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors" }, [
                                m("td", { class: "px-6 py-4 font-medium text-gray-800 dark:text-white" }, target.targetAssign),
                                m("td", { class: "px-6 py-4" }, [
                                    m("span", { 
                                        class: `px-2 py-1 rounded text-xs font-semibold ${
                                            target.targetType === 'deposit' ? 'bg-green-100 text-green-700' :
                                            target.targetType === 'withdrawal' ? 'bg-blue-100 text-blue-700' :
                                            'bg-orange-100 text-orange-700'
                                        }`
                                    }, 
                                    target.targetType === 'deposit' ? 'Setoran' :
                                    target.targetType === 'withdrawal' ? 'Penarikan' : 'Pinjaman')
                                ]),
                                m("td", { class: "px-6 py-4 capitalize text-gray-600 dark:text-gray-400" }, target.targetInterval === 'daily' ? 'Harian' : target.targetInterval === 'weekly' ? 'Mingguan' : 'Bulanan'),
                                m("td", { class: "px-6 py-4 text-right font-mono font-bold text-gray-800 dark:text-white" }, 
                                    `${target.targetNumber} Transaksi`
                                ),
                                m("td", { class: "px-6 py-4 text-center" }, [
                                    m("button", {
                                        class: "text-red-500 hover:text-red-700 transition-colors p-2 rounded-full hover:bg-red-50 dark:hover:bg-red-900/30",
                                        onclick: () => this.deleteTarget(target.id)
                                    }, m("i", { class: "ri-delete-bin-line text-lg" }))
                                ])
                            ]))
                        ])
                    ])
                ])
            ])
        ]);
    }
};

export default KinerjaTarget;
